<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="end">
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-slides class="walkthrough-slides" pager="true">
    <ion-slide class="last-slide illustration-and-decoration-slide">
      <ion-row class="slide-inner-row cliccabile" (click)="vaiAFunzioni()">
        <div class="mainlogo cliccabile" (click)="vaiAFunzioni()" style="background-image: url('/assets/ICST-BLK.png');"></div>
        <!-- <ion-col class="illustration-col">
          <app-aspect-ratio [ratio]="{w:924, h:819}">
            <app-image-shell class="illustration-image" animation="spinner" [src]="'./assets/sample-images/walkthrough/walkthrough-illustration-4.svg'" [alt]="'walkthrough'"></app-image-shell>
          </app-aspect-ratio>
        </ion-col>
      -->
        <ion-col class="decoration-col">
          <!-- http://jxnblk.com/paths/?d=M0%200%20L64%200%20L64%2010%20Q56%2024%2046%2012%20Q34%200%2026%208%20Q10%2022%200%208%20Z -->
          <svg class="vector-decoration" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" height="100px" width="100%" viewBox="0 0 64 18" style="enable-background:new 0 0 64 24;" xml:space="preserve" preserveAspectRatio="none">
            <path d="M0 0 L64 0 L64 10 Q56 24 46 12 Q34 0 26 8 Q10 22 0 8 Z"/>
          </svg>
        </ion-col>
        <ion-col class="info-col">
          <div class="info-col-bg1"></div>
          <div class="info-col-bg2"></div>
          <ion-row class="info-outer">
            <ion-col style="display: none;">
              <div class="info-wrapper">
                <h3 class="info-title">Italian Choice</h3>
                <p class="info-paragraph">
                  Dubai Palm Marina East Dubai, Emirati Arabi Uniti
                </p>
              </div>
            </ion-col>
            <ion-col class="call-to-actions-wrapper">
              <!-- <ion-button class="get-started-button" expand="block" [routerLink]="['servizi']">Vedi tutti i servizi</ion-button> -->
              <ion-row class="alt-call-to-action-row">
                <!-- <span class="cta-leading-text">Oppure accedi direttamente a</span> -->
                <!--
                <ion-button class="login-button" fill="clear" [routerLink]="['funzioni']">
                  Italian Choice Sports Club
                </ion-button>
                -->
              </ion-row>
            </ion-col>
          </ion-row>
        </ion-col>
      </ion-row>
    </ion-slide>
  </ion-slides>
</ion-content>
